import {
  makeDataState,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';


const initialState = {
  episode: makeDataState(),
};


export default (state = initialState, action) => {
  switch (action.type) {
    // fetch episode
    case `${t.FETCH_MY_EPISODE}_PENDING`:
      return {
        ...state,
        episode: {
          ...state.episode,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MY_EPISODE}_SUCCESS`:
      return {
        ...state,
        episode: {
          ...state.epsiode,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_MY_EPISODE}_ERROR`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.ERROR,
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/episodeCreateEdit/reducer.js